// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zLczYiKi2OYjOJeLoglr{justify-content:space-between;align-items:center;display:flex}.AiiWE_pfbHUWOwmZsQGb{margin-bottom:16px;text-decoration:none}.aTyQpn5zJgwQq4yKWr2T{padding-left:4px}.E331eiLQJ3UI6TQBFV4q a{margin-left:4px;text-decoration:none}.hrKa77ydMpArbdNjcLo0{flex-direction:column;justify-content:center;align-items:center;gap:16px;height:200px;display:flex}.vy_oWDQ2oAQ3Is97LCZU{height:50px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsWrapper": `zLczYiKi2OYjOJeLoglr`,
	"addNumberButton": `AiiWE_pfbHUWOwmZsQGb`,
	"assignedNumbersLength": `aTyQpn5zJgwQq4yKWr2T`,
	"readMore": `E331eiLQJ3UI6TQBFV4q`,
	"spinnerLoaderWrapper": `hrKa77ydMpArbdNjcLo0`,
	"spinnerLoader": `vy_oWDQ2oAQ3Is97LCZU`
};
export default ___CSS_LOADER_EXPORT___;
